export const SHOW_CUSTOMIZE_IT_CARD = 'SHOW_CUSTOMIZE_IT_CARD';
export const CLOSE_CUSTOMIZE_IT_CARD = 'CLOSE_CUSTOMIZE_IT_CARD';

export const showCustomizeItCard = (mealId, customizeItLabel) => ({
  type: SHOW_CUSTOMIZE_IT_CARD,
  mealId,
  customizeItLabel,
});

export const closeCustomizeItCard = () => ({
  type: CLOSE_CUSTOMIZE_IT_CARD,
});
